'use strict';

/**
 * Low-level communication handler for the User data service.
 * Uses Q-based promises for all operations.
 */
/* global jQuery */
(function ($) {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Creates a new SecurityRoleService object.
   *
   * Argument 'securityRoleServiceUrl' - The URL to the user data service in the Content REST API.
   * Argument 'serviceSettings' - An object containing settings for this service.
   *
   * The 'serviceSettings' object should look like the following:
   *
   * {
   *   customQ: customQObject,
   *   cacheBusting: boolean
   * }
   *
   * Property 'customQ' is an implementation of a promise based Q library,
   * i.e Angular $q. Defaults to a global Q.
   *
   * Property 'cacheBusting' indicates whether cache busting strategies
   * should be used when reading user data from the server in order to get around
   * browser caching bugs (read: Safari). Defaults to false.
   *
   * Returns a new SecurityRoleService object.
   */
  atex.aceui.service.SecurityRoleService = function (securityRoleServiceUrl, serviceSettings) {
    var settings = Object.assign({}, serviceSettings);
    var q = settings.customQ || window.Q;

    return {
      /**
       * Retrieves a list of all security roles in the system.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.authToken - the authorization token to use for the user data request
       *
       * @typedef {Array} Roles - List of roles like: '[ { name: $NAME, permissions: $PERMISSIONS_OBJECT }, ... ]'
       *
       * @returns {Promise.<Roles, atex.aceui.error.Error>}
       */
      getAllRoles: function (transferInfo) {
        var deferred = q.defer();

        var fullUrl = (settings.cacheBusting)?
          securityRoleServiceUrl + '?cacheBusting=' + Math.random().toString().substring(2):
          securityRoleServiceUrl;

        $.ajax(fullUrl, {
          dataType: 'json',

          beforeSend: function (jqXHR) {
            if (transferInfo.authToken !== undefined) {
              jqXHR.setRequestHeader('X-Auth-Token', transferInfo.authToken);
            }
          },

          success: function (data) {
            deferred.resolve(data);
          },

          error: function (jqXHR) {
            var e = atex.aceui.HTTPUtils.createError(jqXHR, 'atex.aceui.service.SecurityRoleService', {
              401: 'Error getting list of roles: User was not correctly authenticated!',
              403: 'Error while getting list of roles: Permission denied.',
              'default': 'Unknown error while getting a list of roles from the Content REST API!'
            });

            e.transferInfo = transferInfo;

            deferred.reject(e);
          }
        });

        return deferred.promise;
      }
    };
  };
})(jQuery);
